import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { SystemHealthService } from "src/app/shared/services/system-health.service";

@Injectable({ providedIn: "root" })
export class systemdownguardGuard implements CanActivate {
  constructor(
    private systemHealth: SystemHealthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    // Not guarded on the "/service-unavailable" route itself, so there is no redirect loop to
    // guard against here - any navigation this guard sees is safe to block outright when down.
    if (!this.systemHealth.isDown()) {
      return true;
    }

    this.router.navigateByUrl("/service-unavailable");
    return false;
  }
}

systemdownguardGuard;
